exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer{color:#fff!important;background-color:#212529;line-height:20px;display:block;padding-bottom:.25rem\n}\n.footer a{color:#fff\n}\n.footer h3{font-size:.96rem;font-weight:700;margin-bottom:0\n}\n.bottom{font-size:12px\n}\n.bottom img,.bottom span{display:inline-block;margin:2px 12px\n}", ""]);

// exports
